import type { FaireProductEntity } from "../../entity_types/product";

export const p_ktqfq6rzrc: FaireProductEntity = {
  token: "p_ktqfq6rzrc",
  type: "product",
  name: "Happy Drops Gummies - Mood & Natural Serotonin Boosting",
  brandToken: "b_sfmertj2fk",
  brandName: "Organifi",
  imageUrl:
    "https://cdn.faire.com/fastly/234e622e1ff0522ec1bfefbf99ed525e185f491e642b949baa92aa756c7a6c56.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13c5c36b2b183b77d9023340d4f21e78c86e077010e37a56045d606d392ddb18.jpeg",
    "https://cdn.faire.com/fastly/783d5d3d8182526f890b4c566cf8177ab3e1eb3724fa55519b28986418e89598.jpeg",
    "https://cdn.faire.com/fastly/92a4449f95dc20c7e5c85edc30d2757ebd169e389c25efad64c9aa20505d99fc.png",
  ],
  priceDollars: 21.5,
  description:
    "Saffron • Gotu Kola • Passionflower • Ginger\n\nThese daily superfood gummies combine potent, clinically studied ingredients for natural mood-lifting, mental calmness, stress relief, and adaptogenic support – with zero negative side effects.\n\nElevate your mood naturally\nSafe for daily use\nFast-acting and powerful\n\nThese tasty superfood gummies combine real natural elements that influence the same brain chemicals and hormones that make you feel happy.",
  tags: [],
  msrpDollars: 43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:12.923Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
